import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent {

  selectedTab;

  @Input()
  tabs: {id: string; label: string}[];

  @Input()
  tabButton: string;

  @Output()
  selectTabAction: EventEmitter<string> = new EventEmitter();

  @Output()
  tabButtonAction: EventEmitter<void> = new EventEmitter();

  constructor() { }

  selectTab(selectedTab) {
    this.selectTabAction.emit(selectedTab);
    this.selectedTab = selectedTab;
  }

  pressTabButton() {
    this.tabButtonAction.emit();
  }

}